import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GUID_PlACEHOLDER } from "../components/ballot/common/constants";

interface ballotCommittee {
  ballotCommitteeData: Record<string, any>;
  updatedCommitteeData: any;
  isBallotCommitteeSubmitted: boolean;
}
const initialState: ballotCommittee = {
  ballotCommitteeData: [],
  updatedCommitteeData: [],
  isBallotCommitteeSubmitted: false,
};
const selectBallotCommittee = createSlice({
  name: "ballotCommittees",
  initialState,
  reducers: {
    initialBallotCommitteeValues: (
  state,
  action: PayloadAction<Record<string, any>>
) => {
  state.ballotCommitteeData = action.payload.value;

  const isRecirculation = action.payload.isRecirculation;
  const ballotId = action.payload.ballotId;

  const formattedObj = action.payload.value.map((committee: any) => {

    let ballotCommitteeId =
      committee.BallotCommitteeId &&
      committee.BallotCommitteeId !== GUID_PlACEHOLDER
        ? committee.BallotCommitteeId
        : GUID_PlACEHOLDER;

    let isNew = ballotCommitteeId === GUID_PlACEHOLDER;

    // ONLY recirculation override
    if (isRecirculation) {
      ballotCommitteeId = GUID_PlACEHOLDER;
      isNew = true;
    }

    return {
      isDirty: isNew ? false : true,
      isNew: isNew ? true : false,
      ballotId: isRecirculation ? ballotId : committee.BallotId,
      committeeId: committee.CommitteeId,
      ballotRecordStatusId: action.payload.statusId,
      forReviewAndComment: committee.ForReviewAndComment,

      // use updated value
      ballotCommitteeId,

      committeeName: committee.CommitteeName,
      isBalanced: committee.IsBalanced,
      isActive: true,
      isDeleted: false,
    };
  });

  state.updatedCommitteeData = formattedObj;
},
    updatedCommitteeData: (
      state,
      action: PayloadAction<Record<string, any>>
    ) => {
      // const filterObj = state.updatedCommitteeData.filter((committee: any) => committee.Committee.Id !== action.payload.value)
      const { value, label, isReview } = action.payload;
      switch (label) {
        case "empty":
          state.updatedCommitteeData = [];
          break;
        case "delete":
                state.updatedCommitteeData = state.updatedCommitteeData.map(
              (committee: any) => {
                if (committee.committeeId !== value) return committee;

                const isNew = committee.ballotCommitteeId === GUID_PlACEHOLDER;

                return {
                  ...committee,
                  isDirty: true,
                  isNew,
                  isActive: false,
                  isDeleted: true,
                  forReviewAndComment: isReview,
                };
              }
            );
          break;
        case "update":
          state.updatedCommitteeData = state.updatedCommitteeData.map(
          (committee: any) => {
            if (committee.committeeId !== value) return committee;

            const isNew = committee.ballotCommitteeId === GUID_PlACEHOLDER;

            return {
              ...committee,
              isDirty: true,
              isNew, 
              isActive: true,
              isDeleted: false,
              forReviewAndComment: isReview,
            };
          }
        );
          break;
        case "new": {
          const index = state.updatedCommitteeData.findIndex(
            (committee: any) => committee.committeeId === value.committeeId
          );

          if (index > -1) {
            // ✅ UPDATE existing entry
            state.updatedCommitteeData[index] = {
              ...state.updatedCommitteeData[index],
              ...value,
            };
          } else {
            // ✅ ADD new entry
            state.updatedCommitteeData.push(value);
          }

          break;
        }
        case "removeNew":
        state.updatedCommitteeData = state.updatedCommitteeData.filter(
          (item: any) => !(item.committeeId === action.payload.value && item.isNew)
        );
        break;
        default:
          break;
      }
    },
    formSubmitted: (state, action: PayloadAction<Record<string, any>>) => {
      state.isBallotCommitteeSubmitted = action.payload.value;
    },
    reset: (state) => {
      state.ballotCommitteeData = [];
      state.updatedCommitteeData = [];
      state.isBallotCommitteeSubmitted = false;
    },
  },
});

export const ballotCommittees = selectBallotCommittee.actions;
export default selectBallotCommittee.reducer;
